export default {
  MT4: 'metaTrader4',
  MT5: 'metaTrader5',
  MT5_DEMO: 'metaTrader5Demo',
};
